import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './PortalDisclaimer.module.scss';

type PortalDisclaimerProps = {
  // 'error' — application unsuccessful; 'neutral' — informational dead ends
  // like an expired hiring-process deadline.
  variant: 'error' | 'neutral';
  icon: ReactNode;
  label: string;
  title: string;
  body: string;
  // Optional meta row under a divider (e.g. deadline date + contact link).
  footer?: ReactNode;
};

/**
 * Full-width portal disclaimer that replaces the branded title + intro when
 * the journey has reached a dead end: application unsuccessful today, an
 * expired hiring-process deadline later.
 */
function PortalDisclaimer({
  variant,
  icon,
  label,
  title,
  body,
  footer,
}: PortalDisclaimerProps) {
  return (
    <div className={clsx(styles.disclaimer, styles[variant])} role="alert">
      <span className={styles.icon} aria-hidden>
        {icon}
      </span>
      <div className={styles.content}>
        <p className={styles.label}>{label}</p>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.body}>{body}</p>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}

export default PortalDisclaimer;
